// Presentation of a successful sign-in, never authentication state. A new
// document restores its cookie session without creating another reminder.
let pendingAccount: string | null = null

export function beginSignInReminder(accountId: string): void {
  pendingAccount = accountId
}

export function clearSignInReminder(): void {
  pendingAccount = null
}

export function claimSignInReminder(accountId: string): boolean {
  if (pendingAccount !== accountId) return false
  pendingAccount = null
  return true
}
